module.exports = __webpack_public_path__ + "static/media/visit_ustka.94a772e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/visit_ustka.png
// module id = 407
// module chunks = 1